import { reportTransferInvoiceTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_TRANSFER_INVOICE_REPORT_FILTERS,
  RESTORE_INITIAL
} = reportTransferInvoiceTypes;

const getInitialState = () => ({
  startDate: newDate(),
  endDate: newDate(),
  station: null,
});

export const reportTransferInvoiceReducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case SET_TRANSFER_INVOICE_REPORT_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return getInitialState();

    default:
      return state;
  }
};
